// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#313131","menuActiveText":"#409eff","subMenuActiveText":"#409eff","menuBg":"#fff","menuHover":"#dde9fc","subMenuBg":"#fff","subMenuHover":"#dde9fc","sideBarWidth":"200px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/variables.scss
// module id = syC2
// module chunks = 26